import { apiService } from '.'

export const auditService = {
  getAuditsByPage,
  getAuditById
}

function getAuditsByPage(start, pageSize, search) {
  return apiService.fetchAuthGet('audit/page?start=' + start + '&pageSize=' + pageSize + '&search=' + search)
    .then(response => {
      return response.data
    })
    .catch(error => {
      return error
    })
}

function getAuditById(id) {
  return apiService.fetchAuthGet('audit/' + id)
    .then(response => {
      return response
    })
    .catch(error => {
      return error
    })
}

